import React from 'react';
import moment from 'moment';
import cx from 'classnames';

import { Overlay } from '../../UIComponents';

import './index.scss';

const stopPropagation = {
  onClick: (e) => e.stopPropagation(),
};

const CampaignDetails = ({ visibility, onClose, campaign }) => {
  return (
    <div className={cx('pane-container', { open: visibility })}>
      {campaign && (
        <Overlay onOverlayClick={onClose} style={{ zIndex: 100 }}>
          <div className="pane campaign-details-pane" {...stopPropagation}>
            <header className="pane__header header">
              <div className="header__info">
                <div style={{ display: 'flex' }}>
                  <div className="name">{campaign.name}</div>
                  {campaign.is_expired && (
                    <span className="status-tag">EXPIRED</span>
                  )}
                </div>
                <a
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    onClose();
                  }}
                  className="header__info__close"
                >
                  &times;
                </a>
              </div>
              <div className="webhook">
                Webhook URL: <span>{campaign.webhook}</span>
              </div>
            </header>
            <div className="pane__content">
              <div className="info">
                <div className="info_data">
                  <div className="name">Campaign info</div>
                  {/* <div className="edit-container" onClick={()=>editFromDetails(campaign)}>
                    <span className="edit-icon"><i className="fas fa-pen"></i></span>
                    <span className="edit">Edit details</span>
                  </div> */}
                </div>
                <div className="info_details">
                  <div className="key">Service:</div>
                  <div className="value">{campaign.service_name}</div>
                </div>
                <div className="info_details">
                  <div className="key">Booking Dates:</div>
                  {campaign.is_expired ? (
                    <div className="value">
                      {moment(campaign.campaign_start).format('MM/DD/YYYY')} -{' '}
                      {moment(campaign.campaign_expiry).format('MM/DD/YYYY')}
                    </div>
                  ) : (
                    <div className="value">
                      Active since{' '}
                      {moment(campaign.campaign_start).format('MM/DD/YYYY')}
                    </div>
                  )}
                </div>
                <div className="info_details">
                  <div className="key">First message from TrueLark:</div>
                  <div className="value">{campaign.firstMessage}</div>
                </div>
              </div>
            </div>
          </div>
        </Overlay>
      )}
    </div>
  );
};

export default CampaignDetails;
